<template>
  <div class="embed-layout">
    <slot></slot>
  </div>
</template>

<script>
/**
 * POS 임베드 레이아웃 (결정 브리프 2026-09-03 · D2).
 *
 * AppBar·SideNav·MenuFrame·로그아웃이 없고 창을 그대로 채운다. DefaultLayout 이 품는 DingDong(주문 알림음)·
 * NoticeDialog·AgreementDialog 는 여기 없으며, `$webSocket.init` 도 `App.vue` 가 임베드 라우트에서 건너뛴다 —
 * 그 넷은 관리자 포털의 세션에 속한 것이지 POS 안의 창에 속한 것이 아니다(사장님은 이미 POS 의 알림을 듣고 있다).
 *
 * 세로는 화면이 자기 안에서 스크롤한다(목록 내부 스크롤, 브리프 D10). 창이 그보다 낮을 때만 바깥이 스크롤된다.
 */
export default {
  name: 'EmbedLayout',
}
</script>

<style scoped>
.embed-layout {
  width: 100%;
  height: 100vh;
  min-height: 100vh;
  overflow: auto;
  background-color: var(--color-bg-page);
  color: var(--color-text-regular);
}
</style>
